import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useStoreon } from 'storeon/react';
import { api } from '@/api';
import LayoutPipeOrWave from './components/LayoutPipeOrWave';
import SchedulePanel from './components/SchedulePanel';
import Schedule from './components/Schedule';
import useModalFlag from '../../hooks/useModalFlag';
import ModalOrder from './components/ModalOrder';

const Applications: React.FC = ({ }) => {
  const { dispatch } = useStoreon();
  const [params] = useSearchParams();
  const order = params.get('order');
  const { flag: modalOrderOpen, setModalFlag: toggleFlagModalOrder } = useModalFlag();
  const [orderInfo, setOrderInfo] = useState<Record<string, any> | null>({});

  const openModal = (date: string | null, order: Record<string, any> | null) => {
    setOrderInfo({ date, order });
    toggleFlagModalOrder()
  }

  useEffect(() => {
    if (order) {
      api.order.getOrder(Number(order))
        .then((res) => {
          openModal(res.start_at, res);
          params.delete('order')
        })
    }
    dispatch('orders/get');
    return () => {
      dispatch('flagOrArray/clear');
      dispatch('ordersInfo/clear');
    }
  }, [])


  return (
    <LayoutPipeOrWave>
      {() => {
        return (
          <>
            <SchedulePanel />
            <Schedule />
            {modalOrderOpen && <ModalOrder data={orderInfo?.order} date={orderInfo?.date} flag={modalOrderOpen} closeModal={toggleFlagModalOrder} />}
          </>
        );
      }}
    </LayoutPipeOrWave>
  );
};

export default Applications;
